//
export enum LinkType {
  URL = "//",
  MAIL = "mailto:",
  TELEPHONE = "tel:",
}
